import { Activity } from '@/shared/state/activityStore';

export const mockActivities: Activity[] = [
  {
    id: '1',
    type: 'planting',
    title: 'Planted tomato seeds',
    description: 'Started 50 tomato seedlings in the greenhouse',
    date: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    photos: ['/placeholder.svg', '/placeholder.svg'],
    location: 'Greenhouse A',
    cropType: 'Tomatoes',
    points: 50,
    tags: ['tomatoes', 'greenhouse', 'seedlings'],
    createdAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: '2',
    type: 'watering',
    title: 'Watered vegetable garden',
    description: 'Deep watering session for all vegetables',
    date: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
    photos: ['/placeholder.svg'],
    location: 'Main Garden',
    points: 30,
    tags: ['watering', 'vegetables'],
    createdAt: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: '3',
    type: 'fertilizing',
    title: 'Applied organic fertilizer',
    description: 'Spread compost over all beds',
    date: new Date().toISOString(),
    photos: ['/placeholder.svg'],
    location: 'All Beds',
    points: 40,
    tags: ['fertilizer', 'organic', 'compost'],
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: '4',
    type: 'harvesting',
    title: 'Harvested lettuce',
    description: 'Collected 20kg of fresh lettuce',
    date: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
    photos: ['/placeholder.svg', '/placeholder.svg', '/placeholder.svg'],
    location: 'Field B',
    cropType: 'Lettuce',
    points: 100,
    tags: ['harvest', 'lettuce'],
    createdAt: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
  },
];

export const generateMockActivity = (): Omit<Activity, 'id' | 'createdAt' | 'updatedAt'> => {
  const types: Activity['type'][] = ['planting', 'watering', 'fertilizing', 'harvesting', 'other'];
  const crops = ['Tomatoes', 'Lettuce', 'Carrots', 'Corn', 'Peppers'];
  const locations = ['Field A', 'Field B', 'Greenhouse', 'Main Garden'];
  
  const type = types[Math.floor(Math.random() * types.length)];
  
  return {
    type,
    title: `${type.charAt(0).toUpperCase() + type.slice(1)} ${crops[Math.floor(Math.random() * crops.length)]}`,
    description: 'Mock activity description',
    date: new Date().toISOString(),
    photos: Array(Math.floor(Math.random() * 3)).fill('/placeholder.svg'),
    location: locations[Math.floor(Math.random() * locations.length)],
    cropType: crops[Math.floor(Math.random() * crops.length)],
    points: Math.floor(Math.random() * 100) + 20,
    tags: ['mock', type],
  };
};
